import { colorBaseGreyWarm50, ProductParagraph, Spacing } from '@issuu/silkscreen';
import React from 'react';
import styled from 'styled-components';
import { StoryContent } from '../Story';
const PublisherBlock = styled.div `
    background-color: ${colorBaseGreyWarm50};
    position: relative;
    display: flex;
    left: 0;
    right: 0;
    margin: auto;
    max-width: 720px;
    padding: 1rem;
    @media (min-width: 720px) {
        padding: 1.5rem 2.25rem;
    }
`;
const PublisherAvatar = styled.img `
    width: 50px;
    height: 50px;
    border-radius: 100%;
`;
const Content = styled(StoryContent) `
    display: flex;
    align-items: center;
    flex: 1;
    width: 100%;
    padding: 0;
    overflow-wrap: break-word;

    > div:last-child {
        flex-shrink: 1;
        min-width: 0;
    }
`;
const PublisherLineShare = styled.div `
    display: flex;
    flex-direction: row-reverse;
    height: 100%;
    flex: 1;
    padding: 0;
    margin: auto;
    > div {
        padding: 0;
        align-items: center;
        justify-content: flex-end;
    }
`;
const A = styled.a `
    text-decoration: none;
    color: inherit;
`;
const PublisherLine = ({ isDesktop = false, onPublicationClicked, onPublisherClicked, publicationTitle, publicationUrl, publisherAvatarUrl, publisherDisplayName, publisherUrl, shareElement, }) => (React.createElement(PublisherBlock, { itemProp: "author" },
    React.createElement(Content, { itemProp: "publisher", itemScope: true, itemType: 'http://schema.org/Organization' },
        React.createElement("div", { itemProp: "logo", itemScope: true, itemType: "https://schema.org/ImageObject" },
            React.createElement(A, { "aria-hidden": true, href: publisherUrl, tabIndex: -1 },
                React.createElement(PublisherAvatar, { alt: "", itemProp: "url", role: "presentation", src: publisherAvatarUrl })),
            React.createElement("meta", { content: "160px", itemProp: "width" }),
            React.createElement("meta", { content: "160px", itemProp: "height" })),
        React.createElement(Spacing, { left: 1 },
            React.createElement(ProductParagraph, { step: "negative-1" },
                "from",
                ' ',
                React.createElement(A, { href: publicationUrl, onClick: onPublicationClicked },
                    React.createElement("strong", null, publicationTitle))),
            React.createElement(Spacing, { top: 1 },
                React.createElement(ProductParagraph, { step: "negative-1" },
                    "by",
                    ' ',
                    React.createElement(A, { href: publisherUrl, onClick: onPublisherClicked },
                        React.createElement("strong", { itemProp: "name" }, publisherDisplayName)))))),
    isDesktop ? React.createElement(PublisherLineShare, null, shareElement) : null));
export default PublisherLine;
//# sourceMappingURL=PublisherLine.js.map